import { SearchIcon, CloseIcon } from '@/components/ui/Icons';
import './NavbarSearchControl.css';

export interface NavbarSearchControlProps {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  placeholder: string;
  ariaLabel: string;
  autoFocus?: boolean;
  /** Дополнительные классы на корневой контейнер (напр. модификатор попапа) */
  className?: string;
}

export function NavbarSearchControl({
  value,
  onChange,
  onClear,
  placeholder,
  ariaLabel,
  autoFocus = false,
  className = '',
}: NavbarSearchControlProps) {
  const rootClass = ['navbar-search', className].filter(Boolean).join(' ');
  return (
    <div className={rootClass} role="search">
      <span className="navbar-search__icon" aria-hidden>
        <SearchIcon size={18} />
      </span>
      <input
        type="text"
        className="navbar-search__input"
        enterKeyHint="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel}
        autoComplete="off"
        spellCheck={false}
        autoFocus={autoFocus}
      />
      {value.trim().length > 0 ? (
        <button
          type="button"
          className="navbar-search__clear"
          onClick={onClear}
          aria-label="Очистить поиск"
          title="Очистить"
        >
          <CloseIcon size={18} />
        </button>
      ) : null}
    </div>
  );
}
